import { render, staticRenderFns } from "./LeatherCity.vue?vue&type=template&id=03a8d75b&scoped=true"
import script from "./LeatherCity.vue?vue&type=script&lang=js"
export * from "./LeatherCity.vue?vue&type=script&lang=js"
import style0 from "./LeatherCity.vue?vue&type=style&index=0&id=03a8d75b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8d75b",
  null
  
)

export default component.exports